module.exports = __webpack_public_path__ + "img/e-bannerespa_1.0190e6ca.png";